import { TiltifyConfigContext } from "@/context/tiltifyConfigContext";
import { useTiltifyConfigState } from "@/hooks/useTiltifyConfig";

export function TiltifyConfigProvider({ children }: { children: React.ReactNode }) {
  const value = useTiltifyConfigState();
  return <TiltifyConfigContext.Provider value={value}>{children}</TiltifyConfigContext.Provider>;
}
